import { createSlice } from '@reduxjs/toolkit';
import { UserPermissionsDetailStateType } from 'src/types/userPermissionsDetail';

const initialState: UserPermissionsDetailStateType = {
    data: null,
    loading: false,
    error: false,
};
export const userPermissionsDetailSlice = createSlice({
    name: 'userPermissionsDetail',
    initialState,
    reducers: {
        getUserPermissionsDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        getUserPermissionsDetailFetchSuccess: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        getUserPermissionsDetailFetchFailure: (state, action) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
        updateUserPermissionsDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        updateUserPermissionsDetailFetchSuccess: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        updateUserPermissionsDetailFetchFailure: (state, action) => {
            // state.data = null;
            state.loading = false;
            state.error = true;
        },
        clearUserPermissionsDetail: () => initialState,
    },
});

export const {
    getUserPermissionsDetailFetch,
    getUserPermissionsDetailFetchSuccess,
    getUserPermissionsDetailFetchFailure,
    updateUserPermissionsDetailFetch,
    updateUserPermissionsDetailFetchSuccess,
    updateUserPermissionsDetailFetchFailure,
    clearUserPermissionsDetail,
} = userPermissionsDetailSlice.actions;

export default userPermissionsDetailSlice.reducer;
